'use strict';

var util = angular.module('gymsystem.util');

util.factory('fileManager', ['$q', '$http', '$modal', 'util', 'jsoncoder', function($q, $http, $modal, util, jsoncoder) {
    var self = {};

    self.open = function(option) {
        $modal.open({
            templateUrl: 'components/filemanager/filemanager.html',
            controller: 'FileManager',
            windowClass: 'huge-modal-window',
            resolve: {
                dialogOption: function() {
                    return option;
                }
            }
        });
    };

    self.chooseFile = function(option) {
        option = option || {};
        option.mode = 'chooseOne';
        option.chooseImage = true;
        option._deferred = $q.defer();
        self.open(option);
        return option._deferred.promise;
    };

    self.loadFileList = function(option) {
        option = option || {};
        var deferred = $q.defer();

        var mapping = {
            originType: 'origin_type',
            originId: 'origin_id',
            imageOnly: 'image_only',
        };

        var data = {};
        for(var key in option) {
            var skey = mapping[key] || key;
            data[skey] = option[key];
        }

        $http.post('/api/utils/file/get_list', data).success(function(response) {
            deferred.resolve(response);
        }).error(deferred.reject);

        return deferred.promise;
    };

    self.getFileByKey = function(key) {
        var deferred = $q.defer();

        $http.post('/api/utils/file/get_file_object_by_key', {key: key}).success(function(response) {
            deferred.resolve(response);
        }).error(deferred.reject);

        return deferred.promise;
    };

    self.fileLinkByKey = function(key, size, option) {
        var result = '/api/utils/file/download?key=' + key;
        if(size) { result += '&size=' + size;}
        if(option && option.notrack) { result += '&notrack'; }
        if(option && option.noredirect) { result += '&noredirect'; }
        return result;
    };

    self.getFileContentByKey = function(key, size, option) {
        var deferred = $q.defer();
        option = option || {};
        option.noredirect = true;
        $http.get(self.fileLinkByKey(key, size, option), {responseType:'blob'}).success(function(file) {
            deferred.resolve(file);
        }).error(deferred.reject);
        return deferred.promise;
    };

    self.fileLinkByObject = function(obj, size, type) {
        if(!obj) {
            return '/assets/img/profile_avatar_man.jpg';
        }
        if(typeof(obj) === 'number') {
            if(!type) {
                return '/assets/img/profile_avatar_man.jpg';
            }
            if(size) {
                return '/api/public/image/get?type=' + type + '&id=' + obj + '&size=' + size + 'x' + size;
            }
            return '/api/public/image/get?type=' + type + '&id=' + obj;
        }
        if (obj.imageurl) {
            if(size) {
                return obj.imageurl + '?width=' + size + '&height=' + size;
            }
            return obj.imageurl;
        }
        if (obj.imagekey) {
            return self.fileLinkByKey(obj.imagekey, size);
        }
        if (obj.imageSrc) {  // payment method
            return obj.imageSrc;
        }
        if (type === 'Product') {
            return '/assets/img/profile_resource.png';
        }
        if (type == 'teamsport') {
            return '/assets/img/teamsport.jpg';
        }
        if (obj.type === 'resource') {
            if (obj.resourceType === 'door') {
                return '/assets/img/profile_resource_door.png';
            } else {
                return '/assets/img/profile_resource.png';
            }
        }
        if (obj.company) {
            return '/assets/img/profile_factory.png';
        }
        if (obj.personalCodeNumber && obj.personalCodeNumber.length >= 12) {
            if((obj.personalCodeNumber[10] % 2) == 0) {
                return '/assets/img/profile_avatar_woman.jpg';
            }
        }
        return '/assets/img/profile_avatar_man.jpg';
    };

    self.decorateSize = function(size) {
        if(!size) {return '0';}

        var k = 0;
        while(size > 1000) {
            size = size / 1024;
            k++;
        }

        var keys = {
            0: '',
            1: 'K',
            2: 'M',
            3: 'G'
        };

        if(size > 100) {
            return size.toFixed(0) + keys[k];
        }
        if(size > 10) {
            return size.toFixed(1) + keys[k];
        }
        return size.toFixed(2) + keys[k];
    };

    self.downloadFileByUrl = function(url) {
        //document.location.href = url;  // works for safari
        var el = document.getElementById('file-manager-download2');
        if(!el) {
            el = document.createElement('a');
            el.id = 'file-manager-download2';
            el.style.display = 'none';
            el.setAttribute('download', '');
            el.setAttribute('target', '_blank');
            document.body.appendChild(el);
        }
        el.href = url;
        el.click();
    };

    self.downloadFileByUrl2 = function(url) {
        var el = document.createElement('iframe');
        el.style.display = 'none';
        el.src = url;
        document.body.appendChild(el);
        setTimeout(function() {
            document.body.removeChild(el);
        }, 600000);
    };

    self.downloadFileFromServer = function(url) {
        return $q.promise(function(resolve, reject) {
            $http.get(url, {responseType: 'blob'}).success(function(data, status, headers) {
                var cd = headers('Content-Disposition'), filename;
                if(cd) {filename = cd.split('filename=')[1];}
                util.download(filename || 'filename', null, null, data);
                resolve();
            }).error(function(data) {
                if(data.type === 'application/json') {
                    var reader = new FileReader();
                    reader.onload = function() {
                        var response;
                        try {
                            response = jsoncoder.decode(JSON.parse(reader.result));
                        } catch(e) {
                            response = data;
                        }
                        reject(response);
                    };
                    reader.readAsText(data);
                } else {
                    reject(data);
                }
            });
        });
    };

    self.downloadFile = function(key) {
        self.downloadFileByUrl('/api/utils/file/download?key=' + key);
    };

    return self;
}]);


// example: <img ng-src="{{product | imageLink:100:'Product'}}" width="100" height="100" />
util.filter('imageLink', ['fileManager', function(fileManager) {
    return function(value, size, kind) {
        if(typeof(value) === 'string') {
            return fileManager.fileLinkByKey(value, size);
        }
        return fileManager.fileLinkByObject(value, size, kind);
    };
}]);


util.filter('decorateSize', ['fileManager', function(fileManager) {
    return fileManager.decorateSize;
}]);


util.controller('FileManagerFileEdit', ['$rootScope', '$scope', '$http', 'dialogOption', 'fileManager', 'alertProvider', 'live',
    function($rootScope, $scope, $http, dialogOption, fileManager, alertProvider, live) {

    $scope.originalFile = dialogOption.file;
    $scope.file = _.clone(dialogOption.file);
    $scope.file.acl = $scope.file.acl || [];

    $scope.alert = '';

    live.subscribe({
        type: 'file',
        action: 'change',
        scope: $scope,
        callback: function(file) {
            if(file.key != $scope.file.key) {return;}
            $scope.alert = 'File was modified by another user';
        }
    });

    $scope.ableToSave = function() {
        if(!$scope.file.name) {return false;}
        if($scope.file.name != $scope.originalFile.name) {return true;}
        var a = $scope.originalFile.acl;
        var b = $scope.file.acl;
        if(a) {a = a.join(',');}
        if(b) {b = b.join(',');}
        return a != b;
    };
    $scope.saveFile = function() {
        $http.post('/api/utils/file/set_prop', {
            key: $scope.file.key,
            name: $scope.file.name,
            acl: $scope.file.acl
        }).then(function() {
            alertProvider.show('success', 'Settings saved');
            dialogOption._deferred.resolve($scope.file);
            $scope.$dismiss();
        }, function() {
            alertProvider.show('error', 'Failed to save settings');
        });
    };
    $scope.getStorageName = (function() {
        var names = {
            0: 'Local storage',
            1: 'Amazon S3',
            2: 'Fake S3',
            3: 'Old storage',
            4: 'S3 Frankfurt',
            5: 'Link',
            6: 'DB'
        };
        return function(storage) {
            return names[storage];
        };
    })();
    $scope.getStaffName = function(id) {
        var staff = id && $scope.getStaff(id);
        if(staff) {
            return staff.name;
        }
        return '';
    };
    $scope.getFileLink = function(key) {
        return 'https://' + $rootScope.getHost() + '/api/utils/file/download?key=' + key;
    };
}]);


util.controller('FileManager', ['$rootScope', '$scope', '$http', 'dialogOption', 'fileManager', 'alertProvider', '$modal', '$q', 'live', 'confirm', 'server', '$filter', '$compile', '$location', function($rootScope, $scope, $http, dialogOption, fileManager, alertProvider, $modal, $q, live, confirm, server, $filter, $compile, $location) {
    var option = dialogOption || {};
    var currentStaffRoles = $scope.currentStaff.roles.map(function(r) { return r.id; });

    $scope.data = {
        fileInputElement: null,
        group: null,
        loading: 0,
    };
    $scope.mimeType = option.mimeType || '*/*';
    $scope.files = [];
    $scope.mode = option.mode || null;
    $scope.chooseImage = !!option.imageOnly;
    $scope.showImageLibrary = function() {
        return option.visibleTabs !== 'files';
    };

    function getOrigin() {
        var result = {};
        if(!$scope.data.group) {
            result = {
                originType: option.originType,
                originId: option.originId
            };
        } else if($scope.data.group === 'my') {
            result = {
                originType: 'Staff',
                originId: $scope.currentStaffId
            };
        }
        if($scope.data.imageMode) {
            result.imageOnly = true;
        }
        return result;  //all
    }

    function rebuild() {
        if($scope.tableControl.update) {
            $scope.tableControl.update();
        }
    }

    live.subscribe({
        type: 'file',
        scope: $scope,
        callback: function(file, event) {
            var item = _.findWhere($scope.files, {key: file.key});
            if(item) {
                _.extend(item, file);
                rebuild();
            } else if (event.action == 'add') {
                var filter = getOrigin();
                if(filter.originId && filter.originId!=file.origin_id) {return;}
                if(filter.originType && filter.originType!=file.origin_type) {return;}
                file._status = 'success';
                $scope.files.unshift(file);
                rebuild();
            }
        }
    });

    $scope.ableToEdit = function(file) {
        if ($scope.mode == 'displayFiles') { return false; }
        if ((file._status == 'danger') || (file._status == 'active')) {return false;}
        return !file.acl || _.intersection(currentStaffRoles, file.acl).length || file.author_id == $scope.currentStaff.id || $scope.currentStaff.superUser;
    };

    var storagesForRemove = {0: true, 1: true, 4: true, 6: true};
    $scope.ableToRemove = function(file) {
        if ($scope.mode == 'displayFiles') { return false; }
        if ((file._status == 'danger') || (file._status == 'active')) {return false;}
        if (!storagesForRemove[file.storage]) { return false; }
        return !file.acl || _.intersection(currentStaffRoles, file.acl).length || file.author_id == $scope.currentStaff.id || $scope.currentStaff.superUser;
    };

    $scope.tab = {
        files: true,
        my: true,
        all: true
    };
    if(option.visibleTabs) {
        $scope.tab = {};
        if(Array.isArray(option.visibleTabs)) {
            option.visibleTabs.forEach(function(key) {
                $scope.tab[key] = true;
            });
        } else {
            $scope.tab[option.visibleTabs] = true;
        }
    }

    $scope.getIcon = function(file) {
        if(file._status == 'active') {return 'fa-spinner';}
        if(file.is_image) {return 'fa-file-image-o';}
        var ext = file.name.split('.').pop();
        return {
            xls: 'fa-file-excel-o',
            xlsx: 'fa-file-excel-o',
            doc: 'fa-file-word-o',
            docx: 'fa-file-word-o',
            mp3: 'fa-music',
            wav: 'fa-music'
        }[ext] || 'fa-file';
    };

    function reloadFiles() {
        var option = getOrigin();
        var options;
        if($scope.chooseImage) {
            options = [
                {originType: 'product'},
                {originType: 'product:inbuilt'},
                {originType: 'trainingcard'},
                {originType: 'teamsport'}
            ];
        } else {
            options = [option];
        }
        if (!_.findWhere(options, {originType: option.originType})) {
            options.push(option);
        }
        $scope.files = [];
        var deferred = $q.defer();
        options.forEach(function(o) {
            fileManager.loadFileList(o).then(function(response) {
                $scope.files.push.apply($scope.files, response);
            });
        });
        deferred.resolve();
        deferred.promise.then(function() {
            rebuild();
        });
    }

    reloadFiles();

    $scope.setGroup = function(group) {
        $scope.data.group = group;
        reloadFiles();
    };

    $scope.toggleImages = function() {
        $scope.data.imageMode = !$scope.data.imageMode;
        reloadFiles();
    };

    var uniqKey = 1;
    function upload(file, uploadOption) {
        var deferred = $q.defer();
        uploadOption = uploadOption || {};
        $scope.data.loading++;

        var origin = getOrigin();
        var fd = new FormData();
        if (uploadOption.filename) {
            fd.append('file', file, uploadOption.filename);
        } else {
            fd.append('file', file);
        }
        fd.append('data', JSON.stringify({
            origin_type: origin.originType,
            origin_id: origin.originId,
            selection: uploadOption.selection
        }));
        var item = {
            key: '_tmp' + (uniqKey++),
            _status: 'active',
            name: file.name
        };
        $scope.files.unshift(item);
        rebuild();

        $http.post('/api/utils/file/upload', fd, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).success(function(response) {
            $scope.data.selectedFile = null;
            $scope.data.fileContent = null;
            $scope.data.fileInputElement.value = '';

            var newItem = _.findWhere($scope.files, {key: response.key});
            if(newItem) {
                var i = $scope.files.indexOf(item);
                if(i>=0) {
                    $scope.files.splice(i, 1);
                }
                item = newItem;
            } else {
                _.extend(item, response);
            }
            item._status = 'success';
            $scope.data.loading--;
            reloadFiles();
            rebuild();
            deferred.resolve(item);
        }).error(function () {
            deferred.reject();
            $scope.data.loading--;
            item._status = 'danger';
            rebuild();
        });
        return deferred.promise;
    }
    $scope.expoUpload = function(file, filename) {
        upload(file, { filename: filename });
    };

    function previewImage(file) {
        var deferred = $q.defer();
        var reader = new FileReader();
        reader.onload = function(e) {
            $modal.open({
                templateUrl: 'components/filemanager/thumbnail.html',
                controller: 'FileManagerThumbnail',
                windowClass: 'huge-modal-window',
                resolve: {
                    option: function() {
                        return {
                            file: file,
                            content: e.target.result,
                            deferred: deferred
                        };
                    }
                }
            });
        };
        reader.onerror = deferred.reject;
        reader.readAsDataURL(file);
        return deferred.promise;
    }

    $scope.fileChosen = function() {
        var files = $scope.data.fileInputElement.files;
        if(!files) {return;}

        if(option.squareThumbnail && window.FileReader) {
            previewImage(files[0]).then(function(response) {
                upload(files[0], response).then(function(file) {
                    if($scope.mode=='chooseOne') {
                        $scope.click(file);
                    }
                });
            });
        } else {
            $scope.$apply(function() {
                for(var i=0;i<files.length;i++) {
                    upload(files[i]);
                }
            });
        }
    };

    $scope.fileInit = function(el) {
        $scope.data.fileInputElement = el;
        el.addEventListener('change', $scope.fileChosen);
        $scope.$on('$destroy', function() {
            el.removeEventListener('change', $scope.fileChosen);
        });
    };

    $scope.click = function(file) {
        if(!$scope.mode) {return;}
        if((file._status == 'danger') || (file._status == 'active')) {return;}
        $scope.$dismiss();
        if(option._deferred) {
            option._deferred.resolve(file);
        }
    };

    if(window.FileReader) {
        var cancel = function(e) {
            if (e.preventDefault) { e.preventDefault(); }
            return false;
        };

        var fileUpload = function(e) {
            if (e.preventDefault) { e.preventDefault(); }
            var files = e.dataTransfer.files;
            if(option.squareThumbnail) {
                previewImage(files[0]).then(function(response) {
                    upload(files[0], response).then(function(file) {
                        if($scope.mode=='chooseOne') {
                            $scope.click(file);
                        }
                    });
                });
            } else {
                $scope.$apply(function() {
                    for(var i=0;i<files.length;i++) {
                        upload(files[i]);
                    }
                });
            }
            return false;
        };

        document.body.addEventListener('dragover', cancel, false);
        document.body.addEventListener('dragenter', cancel, false);
        document.body.addEventListener('drop', fileUpload, false);

        $scope.$on('$destroy', function() {
            document.body.removeEventListener('dragover', cancel);
            document.body.removeEventListener('dragenter', cancel);
            document.body.removeEventListener('drop', fileUpload);
        });
    }

    var doRemoveFile = function(fileKey) {
        server.post2('/api/utils/file/remove', {key: fileKey}).then(function() {
            alertProvider.show('success', 'DELETE_FILE_SUCCESS');
            reloadFiles();
        }).catch(function() {
            alertProvider.show('error', 'DELETE_FILE_ERROR');
        });
    };

    $scope.remove = function(file) {
        server.get('/api/utils/file/check_being_used', {key: file.key}).then(function(result) {
            var msg = '';
            if (result.beingUsed) {
                msg = $filter('translate')('REMOVE_USING_FILE_CONFIRM').format(result.tables);
            } else {
                msg = $filter('translate')('REMOVE_UNUSING_FILE_CONFIRM');
            }
            confirm.show(msg).then(function() {
                doRemoveFile(file.key);
            });
        });
    };

    $scope.targetTabName = $scope.chooseImage && option.originType ? option.originType.capitalize() : '';

    $scope.showTab = function() {
        var path = $location.$$path;
        return !path.includes('courses') && !path.includes('mailings');
    };

    $scope.configColumns = [
        {
            field: 'image',
            src: function(file) {
                if(!file.is_image) {return null;}
                return fileManager.fileLinkByKey(file.key, 50, {notrack: true});
            }
        },
        {
            field: 'name',
            title: 'Name',
            getValue: function(file) {
                if(file.acl && file.acl.length) {
                    return '<i class="fa fa-lock"></i> ' + file.name;
                }
                return file.name;
            }
        },
        {field: 'created', title: 'Created'},
        {field: 'last_access', title: 'Last access'},
        {field: 'size', title: 'Size', getValue: function(file) {return fileManager.decorateSize(file.size);}}
    ];

    $scope.configButtons = [
            {
                title: 'Change',
                buttonClass: 'btn-warning',
                visible: function(file) {
                    if(!file) {return false;}
                    return $scope.ableToEdit(file);
                },
                onClick: function(file) {
                    var option = {};
                    option.file = file;
                    option._deferred = $q.defer();
                    option._deferred.promise.then(function(result) {
                        _.extend(file, result);
                        rebuild();
                    });

                    $modal.open({
                        templateUrl: 'components/filemanager/fileedit.html',
                        controller: 'FileManagerFileEdit',
                        resolve: {
                            dialogOption: function() {
                                return option;
                            }
                        }
                    });
                },
                tooltip: 'Change details'
            }
        ];

    $scope.tableControl = {};
    $scope.tableList = {
        idKey: 'key',
        getItems: function() {
            return $scope.files;
        },
        countSuffixList: $scope.chooseImage ? ['image', 'images'] : ['file', 'files'],
        rowClass: function(file) {
            if(!file) {return '';}
            return file._status || '';
        },
        tableLimit: 10,
        headerClass: 'glyphicon glyphicon-credit-card',
        itemFilter: function(file) {
            return file.origin_type == option.originType;
        },
        columns: $scope.configColumns,
        buttons: $scope.configButtons
    };

    $scope.tableListGeneral = {
        idKey: 'key',
        getItems: function() {
            return $scope.files;
        },
        countSuffixList: ['image', 'images'],
        rowClass: function(file) {
            if(!file) {return '';}
            return file._status || '';
        },
        tableLimit: 10,
        headerClass: 'glyphicon glyphicon-credit-card',
        itemFilter: function(file) {
            return file.origin_type !== 'product:inbuilt';
        },
        hideSearch: true,
        columns: $scope.configColumns,
        buttons: $scope.configButtons
    };

    $scope.sourceCodeImages = {
        idKey: 'key',
        getItems: function() {
            return $scope.files;
        },
        countSuffixList: ['image', 'images'],
        rowClass: function(file) {
            if(!file) {return '';}
            return file._status || '';
        },
        tableLimit: 10,
        headerClass: 'glyphicon glyphicon-credit-card',
        itemFilter: function(file) {
            return file.origin_type === 'product:inbuilt';
        },
        hideSearch: true,
        columns: $scope.configColumns.slice(0, 4),
        buttons: $scope.configButtons
    };

    if($scope.mode=='chooseOne') {
        $scope.tableList.rowClick = $scope.click;
        $scope.tableListGeneral.rowClick = $scope.click;
        $scope.configButtons.push({ title: 'Choose', onClick: $scope.click });
    } else {
        var downloadButton = {
            title: 'Download',
            buttonClass: 'btn-success',
            visible: function(file) {
                if(!file) {return false;}
                if((file._status == 'danger') || (file._status == 'active')) {return false;}
                return true;
            },
            onClick: function(file) {
                fileManager.downloadFile(file.key);
            }
        };
        $scope.configButtons.push(downloadButton);
    }
    $scope.configButtons.push({ title: 'Remove', onClick: $scope.remove, buttonClass: 'btn-danger', visible: $scope.ableToRemove });
}]);


util.controller('FileManagerThumbnail', ['$scope', 'option', function($scope, option) {
    $scope.data = {
        imageContent: option.content
    };
    $scope.unSafeFileMsg = !option.file.type ? 'Unsafe file' : 'File format unmatched';
    $scope.isUnsafeFile = function() {
        return !option.file.type || !option.file.type.includes('image');
    };

    $scope.upload = function() {
        $scope.loadingStatus = {};
        $scope.loadingStatus.loading = true;
        option.deferred.resolve({
            selection: $scope.data.selection
        });
        $scope.loadingStatus.loading = false;
        $scope.$close();
    };
}]);